{
  "pages": {
    "listTitle": "Quản lý kho",
    "detailsTitle": "Chi tiết mặt hàng",
    "addTitle": "Thêm mặt hàng",
    "editTitle": "Sửa mặt hàng",
    "reportsTitle": "Báo cáo kho",
    "permissionDenied": "Bạn không có quyền xem danh mục hàng.",
    "loading": "Đang tải mặt hàng...",
    "notFound": "Không tìm thấy mặt hàng.",
    "backToList": "Về danh mục kho"
  },
  "config": {
    "title": "Cấu hình kho",
    "tabs": {
      "catalog": "Danh mục hàng",
      "suppliers": "Nhà cung cấp",
      "warehouses": "Kho",
      "taxonomy": "Loại & đơn vị"
    },
    "tabsAria": "Phần cấu hình kho"
  },
  "taxonomy": {
    "sectionsAria": "Loại hàng và đơn vị tính",
    "sections": {
      "category": "Loại hàng",
      "unit": "Đơn vị tính"
    },
    "hints": {
      "category": "Loại hàng dùng phân nhóm danh mục và lọc báo cáo. Mã nội bộ giữ nguyên khi đổi tên.",
      "unit": "Đơn vị tính hiển thị trên phiếu và danh mục. Không thể ngưng dùng nếu còn mặt hàng đang dùng."
    },
    "fields": {
      "origin": "Nguồn"
    },
    "origin": {
      "system": "Mặc định",
      "custom": "Tùy chỉnh"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngưng dùng"
    },
    "searchPlaceholder": "Tìm {{kind}}…",
    "empty": "Chưa có mục nào",
    "emptySearch": "Không tìm thấy kết quả",
    "actions": {
      "add": "Thêm {{kind}}"
    },
    "dialog": {
      "addTitle": "Thêm {{kind}}",
      "editTitle": "Sửa {{kind}}"
    },
    "quickCreate": {
      "namePlaceholderCategory": "Ví dụ: Vật tư tiêu hao",
      "namePlaceholderUnit": "Ví dụ: Cái"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên"
    },
    "toasts": {
      "created": "Đã thêm",
      "updated": "Đã cập nhật",
      "saveFailed": "Lưu thất bại",
      "loadFailed": "Không tải được danh mục loại & đơn vị"
    },
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử loại & đơn vị",
      "empty": "Chưa có thay đổi nào trên mục này."
    }
  },
  "catalog": {
    "search": "Tìm kiếm kho",
    "allCategories": "Tất cả danh mục",
    "allStatuses": "Tất cả trạng thái",
    "addItem": "Thêm mặt hàng",
    "empty": "Không tìm thấy mặt hàng nào",
    "sections": {
      "basicInfo": "Thông tin cơ bản",
      "stockInfo": "Thông tin tồn kho",
      "supplierInfo": "Thông tin nhà cung cấp",
      "additionalDetails": "Chi tiết bổ sung",
      "itemOverview": "Tổng quan mặt hàng",
      "stockHistory": "Lịch sử tồn kho",
      "serialsInStock": "Serial trong kho",
      "lotsInStock": "Lô trong kho"
    },
    "stockViaDocumentsHint": "Tồn kho chỉ thay đổi qua phiếu nhập, xuất, điều chuyển hoặc kiểm kê — không nhập số lượng tại đây.",
    "stockReadOnlyHint": "Chỉ đọc. Điều chỉnh tồn qua phiếu kho."
  },
  "stockIn": {
    "listTitle": "Nhập kho",
    "createTitle": "Phiếu nhập kho mới",
    "editTitle": "Sửa phiếu nhập kho",
    "docTitle": "Phiếu nhập kho",
    "detailTitle": "Chi tiết phiếu nhập kho",
    "notFound": "Không tìm thấy phiếu nhập kho",
    "permissionDenied": "Bạn không có quyền xem phiếu nhập kho.",
    "newButton": "Tạo phiếu nhập",
    "empty": "Không tìm thấy phiếu nhập kho",
    "postConfirmTitle": "Ghi sổ phiếu nhập?",
    "postConfirmBody": "Thao tác này sẽ tăng tồn kho cho tất cả dòng và tạo biến động kho.",
    "cancelConfirmTitle": "Hủy phiếu nhập?",
    "cancelConfirmBody": "Phiếu đã ghi sổ sẽ chuyển sang Đã hủy và tồn kho được đảo lại. Phiếu vẫn nằm trong danh sách.",
    "cancelReceipt": "Hủy phiếu",
    "voidBlocked": "Không hủy được vì hàng trên phiếu đã xuất hoặc không còn đủ tồn.",
    "deleteReceipt": "Xóa phiếu",
    "deleteConfirmTitle": "Xóa phiếu nhập?",
    "deleteConfirmBody": "Phiếu nháp sẽ bị xóa khỏi danh sách. Tồn kho không đổi.",
    "deleted": "Đã xóa phiếu nhập",
    "deleteFailed": "Xóa phiếu nhập thất bại",
    "draftCreated": "Đã tạo phiếu nhập nháp",
    "posted": "Đã ghi sổ phiếu nhập",
    "cancelled": "Đã hủy phiếu nhập",
    "createFailed": "Tạo phiếu nhập thất bại",
    "updateFailed": "Cập nhật phiếu nhập thất bại",
    "postFailed": "Ghi sổ phiếu nhập thất bại",
    "cancelFailed": "Hủy phiếu nhập thất bại",
    "loadFailed": "Không tải được phiếu nhập",
    "loadListFailed": "Không tải được danh sách phiếu nhập",
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử phiếu nhập",
      "empty": "Chưa có thay đổi nào trên phiếu này."
    },
    "print": {
      "action": "In phiếu",
      "comingSoon": "Sắp có"
    },
    "export": {
      "documentsAction": "Xuất danh sách phiếu",
      "linesAction": "Xuất chi tiết dòng hàng",
      "documentsSuccess": "Đã xuất danh sách phiếu nhập",
      "documentsFailed": "Không xuất được danh sách phiếu nhập",
      "documentsEmpty": "Không có phiếu nhập nào để xuất với bộ lọc hiện tại",
      "linesSuccess": "Đã xuất chi tiết dòng hàng phiếu nhập",
      "linesFailed": "Không xuất được chi tiết dòng hàng phiếu nhập",
      "linesEmpty": "Không có dòng hàng nào để xuất với bộ lọc hiện tại"
    },
    "filters": {
      "trigger": "Bộ lọc",
      "clearAll": "Xóa tất cả",
      "apply": "Áp dụng",
      "selectStatus": "Chọn trạng thái",
      "period": "Thời gian",
      "periodPlaceholder": "Chọn khoảng ngày",
      "selectClinic": "Chọn phòng khám",
      "allClinics": "Tất cả phòng khám",
      "selectWarehouse": "Chọn kho",
      "allWarehouses": "Tất cả kho"
    }
  },
  "stockOut": {
    "listTitle": "Xuất kho",
    "createTitle": "Phiếu xuất kho mới",
    "editTitle": "Sửa phiếu xuất kho",
    "docTitle": "Phiếu xuất kho",
    "detailTitle": "Chi tiết phiếu xuất kho",
    "notFound": "Không tìm thấy phiếu xuất kho",
    "permissionDenied": "Bạn không có quyền xem phiếu xuất kho.",
    "newButton": "Tạo phiếu xuất",
    "empty": "Không tìm thấy phiếu xuất kho",
    "postConfirmTitle": "Ghi sổ phiếu xuất?",
    "postConfirmBody": "Thao tác này sẽ giảm tồn kho cho tất cả dòng và tạo biến động kho.",
    "cancelConfirmTitle": "Hủy phiếu xuất?",
    "cancelConfirmBody": "Phiếu đã ghi sổ sẽ chuyển sang Đã hủy và tồn kho được hoàn lại. Phiếu vẫn nằm trong danh sách.",
    "cancelIssue": "Hủy phiếu",
    "voidBlocked": "Không hủy được vì hàng trên phiếu không còn ở trạng thái đã xuất.",
    "deleteIssue": "Xóa phiếu",
    "deleteConfirmTitle": "Xóa phiếu xuất?",
    "deleteConfirmBody": "Phiếu nháp sẽ bị xóa khỏi danh sách. Tồn kho không đổi.",
    "deleted": "Đã xóa phiếu xuất",
    "deleteFailed": "Xóa phiếu xuất thất bại",
    "draftCreated": "Đã tạo phiếu xuất nháp",
    "posted": "Đã ghi sổ phiếu xuất",
    "cancelled": "Đã hủy phiếu xuất",
    "createFailed": "Tạo phiếu xuất thất bại",
    "updateFailed": "Cập nhật phiếu xuất thất bại",
    "postFailed": "Ghi sổ phiếu xuất thất bại",
    "cancelFailed": "Hủy phiếu xuất thất bại",
    "loadFailed": "Không tải được phiếu xuất",
    "loadListFailed": "Không tải được danh sách phiếu xuất",
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử phiếu xuất",
      "empty": "Chưa có thay đổi nào trên phiếu này."
    },
    "print": {
      "action": "In phiếu",
      "comingSoon": "Sắp có"
    },
    "export": {
      "documentsAction": "Xuất danh sách phiếu",
      "linesAction": "Xuất chi tiết dòng hàng",
      "documentsSuccess": "Đã xuất danh sách phiếu xuất",
      "documentsFailed": "Không xuất được danh sách phiếu xuất",
      "documentsEmpty": "Không có phiếu xuất nào để xuất với bộ lọc hiện tại",
      "linesSuccess": "Đã xuất chi tiết dòng hàng phiếu xuất",
      "linesFailed": "Không xuất được chi tiết dòng hàng phiếu xuất",
      "linesEmpty": "Không có dòng hàng nào để xuất với bộ lọc hiện tại"
    },
    "filters": {
      "trigger": "Bộ lọc",
      "clearAll": "Xóa tất cả",
      "apply": "Áp dụng",
      "periodPlaceholder": "Chọn khoảng ngày",
      "selectReason": "Chọn lý do xuất",
      "allReasons": "Tất cả lý do xuất",
      "selectPatient": "Chọn bệnh nhân",
      "selectStatus": "Chọn trạng thái",
      "selectClinic": "Chọn phòng khám",
      "allClinics": "Tất cả phòng khám",
      "selectWarehouse": "Chọn kho",
      "allWarehouses": "Tất cả kho"
    }
  },
  "stocktake": {
    "listTitle": "Kiểm kê",
    "createTitle": "Phiếu kiểm kê mới",
    "editTitle": "Sửa phiếu kiểm kê",
    "detailTitle": "Chi tiết phiếu kiểm kê",
    "docTitle": "Phiếu kiểm kê",
    "notFound": "Không tìm thấy phiếu kiểm kê",
    "permissionDenied": "Bạn không có quyền xem phiếu kiểm kê.",
    "newButton": "Tạo phiếu kiểm",
    "empty": "Không tìm thấy phiếu kiểm kê",
    "loadSystemSerials": "Tải SN hệ thống",
    "serialHint": "Dán danh sách serial đang có thực tế; số lượng = số mã",
    "postConfirmTitle": "Ghi sổ kiểm kê?",
    "postConfirmBody": "Thao tác này sẽ điều chỉnh tồn theo chênh lệch giữa hệ thống và thực tế.",
    "posting": "Đang ghi sổ...",
    "cancelling": "Đang hủy...",
    "deleteStocktake": "Xóa phiếu",
    "deleteConfirmTitle": "Xóa phiếu kiểm kê?",
    "deleteConfirmBody": "Phiếu nháp sẽ bị xóa khỏi danh sách. Tồn kho không đổi.",
    "deleted": "Đã xóa phiếu kiểm kê",
    "deleteFailed": "Xóa phiếu kiểm kê thất bại",
    "cancelConfirmTitle": "Hủy phiếu kiểm kê?",
    "cancelConfirmBody": "Phiếu đã ghi sổ sẽ chuyển sang Đã hủy và tồn kho được đảo lại. Phiếu vẫn nằm trong danh sách.",
    "cancelStocktake": "Hủy phiếu",
    "voidBlocked": "Không hủy được vì tồn hiện tại không còn đủ để đảo chênh lệch kiểm kê.",
    "draftCreated": "Đã tạo phiếu kiểm kê nháp",
    "posted": "Đã ghi sổ phiếu kiểm kê",
    "cancelled": "Đã hủy phiếu kiểm kê",
    "createFailed": "Tạo phiếu kiểm kê thất bại",
    "updateFailed": "Cập nhật phiếu kiểm kê thất bại",
    "postFailed": "Ghi sổ phiếu kiểm kê thất bại",
    "cancelFailed": "Hủy phiếu kiểm kê thất bại",
    "loadFailed": "Không tải được phiếu kiểm kê",
    "loadListFailed": "Không tải được danh sách phiếu kiểm kê",
    "filters": {
      "trigger": "Bộ lọc",
      "clearAll": "Xóa tất cả",
      "apply": "Áp dụng",
      "selectStatus": "Chọn trạng thái",
      "period": "Thời gian",
      "periodPlaceholder": "Chọn khoảng ngày",
      "selectWarehouse": "Chọn kho",
      "allWarehouses": "Tất cả kho"
    },
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử phiếu kiểm kê",
      "empty": "Chưa có thay đổi nào trên phiếu này."
    },
    "print": {
      "action": "In phiếu",
      "comingSoon": "Sắp có"
    },
    "export": {
      "documentsAction": "Xuất danh sách phiếu",
      "linesAction": "Xuất chi tiết dòng hàng",
      "documentsSuccess": "Đã xuất danh sách phiếu kiểm kê",
      "documentsFailed": "Không xuất được danh sách phiếu kiểm kê",
      "documentsEmpty": "Không có phiếu kiểm kê nào để xuất với bộ lọc hiện tại",
      "linesSuccess": "Đã xuất chi tiết dòng hàng phiếu kiểm kê",
      "linesFailed": "Không xuất được chi tiết dòng hàng phiếu kiểm kê",
      "linesEmpty": "Không có dòng hàng nào để xuất với bộ lọc hiện tại"
    }
  },
  "transfer": {
    "listTitle": "Điều chuyển kho",
    "createTitle": "Phiếu điều chuyển mới",
    "editTitle": "Sửa phiếu điều chuyển",
    "docTitle": "Phiếu điều chuyển",
    "detailTitle": "Chi tiết phiếu điều chuyển",
    "notFound": "Không tìm thấy phiếu điều chuyển",
    "permissionDenied": "Bạn không có quyền xem phiếu điều chuyển.",
    "newButton": "Tạo phiếu chuyển",
    "empty": "Không tìm thấy phiếu điều chuyển",
    "postConfirmTitle": "Ghi sổ điều chuyển?",
    "postConfirmBody": "Thao tác này sẽ giảm tồn ở kho nguồn và tăng tồn ở kho đích.",
    "posting": "Đang ghi sổ...",
    "cancelConfirmTitle": "Hủy phiếu điều chuyển?",
    "cancelConfirmBody": "Phiếu đã ghi sổ sẽ chuyển sang Đã hủy và tồn kho được đảo lại. Phiếu vẫn nằm trong danh sách.",
    "cancelTransfer": "Hủy phiếu",
    "cancelling": "Đang hủy...",
    "voidBlocked": "Không hủy được vì hàng trên phiếu không còn đủ ở kho đích.",
    "deleteTransfer": "Xóa phiếu",
    "deleteConfirmTitle": "Xóa phiếu điều chuyển?",
    "deleteConfirmBody": "Phiếu nháp sẽ bị xóa khỏi danh sách. Tồn kho không đổi.",
    "deleted": "Đã xóa phiếu điều chuyển",
    "deleteFailed": "Xóa phiếu điều chuyển thất bại",
    "draftCreated": "Đã tạo phiếu điều chuyển nháp",
    "posted": "Đã ghi sổ phiếu điều chuyển",
    "cancelled": "Đã hủy phiếu điều chuyển",
    "createFailed": "Tạo phiếu điều chuyển thất bại",
    "updateFailed": "Cập nhật phiếu điều chuyển thất bại",
    "postFailed": "Ghi sổ phiếu điều chuyển thất bại",
    "cancelFailed": "Hủy phiếu điều chuyển thất bại",
    "loadFailed": "Không tải được phiếu điều chuyển",
    "loadListFailed": "Không tải được danh sách phiếu điều chuyển",
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử phiếu điều chuyển",
      "empty": "Chưa có thay đổi nào trên phiếu này."
    },
    "print": {
      "action": "In phiếu",
      "comingSoon": "Sắp có"
    },
    "export": {
      "documentsAction": "Xuất danh sách phiếu",
      "linesAction": "Xuất chi tiết dòng hàng",
      "documentsSuccess": "Đã xuất danh sách phiếu điều chuyển",
      "documentsFailed": "Không xuất được danh sách phiếu điều chuyển",
      "documentsEmpty": "Không có phiếu điều chuyển nào để xuất với bộ lọc hiện tại",
      "linesSuccess": "Đã xuất chi tiết dòng hàng phiếu điều chuyển",
      "linesFailed": "Không xuất được chi tiết dòng hàng phiếu điều chuyển",
      "linesEmpty": "Không có dòng hàng nào để xuất với bộ lọc hiện tại"
    },
    "noDestinationWarehouse": "Chưa có kho đích khác",
    "filters": {
      "trigger": "Bộ lọc",
      "clearAll": "Xóa tất cả",
      "apply": "Áp dụng",
      "selectStatus": "Chọn trạng thái",
      "period": "Thời gian",
      "periodPlaceholder": "Chọn khoảng ngày",
      "selectFromWarehouse": "Chọn kho nguồn",
      "allFromWarehouses": "Tất cả kho nguồn",
      "selectToWarehouse": "Chọn kho đích",
      "allToWarehouses": "Tất cả kho đích"
    }
  },
  "reports": {
    "tabs": {
      "ledger": "Sổ cái",
      "balance": "Tồn kho",
      "movement": "Nhập – Xuất – Tồn",
      "lowStock": "Tồn thấp",
      "expiringLots": "Sắp hết hạn"
    },
    "searchItem": "Tìm mặt hàng",
    "groupByCategory": "Nhóm theo danh mục",
    "apply": "Áp dụng",
    "from": "Từ ngày",
    "to": "Đến ngày",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "dateAllLabel": "Tất cả",
    "ledgerAllDatesHint": "Từ biến động đầu tiên đến hôm nay. Chọn kho để xem toàn bộ lịch sử trong kho đó.",
    "ledgerAllDatesWarehouseHint": "Toàn bộ biến động trong kho đã chọn, không giới hạn ngày.",
    "permissionDenied": "Bạn không có quyền xem báo cáo kho.",
    "summary": {
      "totalQuantity": "Tổng số lượng",
      "totalValue": "Giá trị tồn",
      "lowStockItems": "Mặt hàng tồn thấp",
      "totalIn": "Tổng nhập",
      "totalOut": "Tổng xuất",
      "netChange": "Biến động ròng",
      "outOfStock": "Hết hàng"
    },
    "empty": {
      "ledger": "Không có biến động trong kỳ",
      "balance": "Không có dữ liệu",
      "movement": "Không có biến động trong kỳ",
      "lowStock": "Không có mặt hàng tồn thấp",
      "expiringLots": "Không có lô sắp hết hạn"
    },
    "withinDays": "Trong {{days}} ngày",
    "daysUntilExpiry": "Còn (ngày)",
    "loadLedgerFailed": "Không tải được sổ cái kho",
    "loadBalanceFailed": "Không tải được báo cáo tồn kho",
    "loadMovementFailed": "Không tải được báo cáo xuất nhập tồn",
    "loadLowStockFailed": "Không tải được báo cáo tồn thấp",
    "loadExpiringLotsFailed": "Không tải được báo cáo lô sắp hết hạn",
    "ledger": {
      "itemClickHint": "Bấm để lọc theo mặt hàng. Ctrl+bấm để xem chi tiết.",
      "documentClickHint": "Bấm để lọc theo phiếu. Ctrl+bấm để mở phiếu.",
      "filters": {
        "trigger": "Bộ lọc",
        "selectCategory": "Chọn danh mục",
        "selectType": "Chọn loại biến động",
        "allTypes": "Tất cả loại biến động",
        "recordedByNoUser": "Nhân sự này chưa có tài khoản đăng nhập, không lọc được theo người thực hiện."
      },
      "export": {
        "action": "Xuất CSV",
        "success": "Đã xuất sổ cái",
        "failed": "Không xuất được sổ cái",
        "empty": "Không có dòng nào để xuất với bộ lọc hiện tại"
      }
    }
  },
  "docStatus": {
    "draft": "Nháp",
    "posted": "Đã ghi sổ",
    "cancelled": "Đã hủy",
    "all": "Tất cả trạng thái"
  },
  "trackingMode": {
    "none": "Không theo dõi chi tiết",
    "lot": "Theo lô / HSD",
    "serial": "Theo serial",
    "serialInLot": "Serial trong lô"
  },
  "itemStatus": {
    "active": "Đang dùng",
    "inStock": "Còn hàng",
    "lowStock": "Sắp hết",
    "outOfStock": "Hết hàng",
    "discontinued": "Ngừng kinh doanh",
    "unknown": "Không xác định"
  },
  "stockState": {
    "in_stock": "Còn hàng",
    "low_stock": "Sắp hết",
    "out_of_stock": "Hết hàng"
  },
  "reasons": {
    "treatment": "Dùng điều trị",
    "internal": "Dùng nội bộ",
    "damaged": "Hư hỏng",
    "expired": "Hết hạn",
    "other": "Khác"
  },
  "movementTypes": {
    "manual": "Thủ công",
    "receipt": "Nhập kho",
    "receipt_void": "Hủy nhập kho",
    "issue": "Xuất kho",
    "issue_void": "Hủy xuất kho",
    "transfer_in": "Nhận điều chuyển",
    "transfer_out": "Xuất điều chuyển",
    "transfer_void": "Hủy điều chuyển",
    "stocktake_adjust": "Kiểm kê",
    "stocktake_void": "Hủy kiểm kê",
    "transfer": "Điều chuyển"
  },
  "categories": {
    "Consumables": "Vật tư tiêu hao",
    "Instruments": "Dụng cụ",
    "Equipment": "Thiết bị",
    "Medicines": "Thuốc",
    "Implants": "Vật liệu cấy ghép",
    "Orthodontic Supplies": "Vật tư chỉnh nha",
    "Office Supplies": "Văn phòng phẩm",
    "Others": "Khác"
  },
  "units": {
    "Piece": "Cái",
    "Box": "Hộp",
    "Pack": "Gói",
    "Set": "Bộ",
    "Kit": "Kit",
    "Bottle": "Chai",
    "Tube": "Tuýp",
    "Syringe": "Xilanh",
    "Gram": "Gram",
    "Kilogram": "Kilogram",
    "Milliliter": "Millilít",
    "Liter": "Lít",
    "Abutment": "Trụ",
    "Other": "Khác"
  },
  "fields": {
    "name": "Tên",
    "sortOrder": "Thứ tự",
    "itemName": "Tên mặt hàng",
    "itemCode": "Mã mặt hàng",
    "category": "Danh mục",
    "selectCategory": "Chọn danh mục",
    "unit": "Đơn vị tính",
    "selectUnit": "Chọn đơn vị",
    "description": "Mô tả",
    "unitPrice": "Đơn giá ({{currency}})",
    "pricePerUnit": "Giá mỗi đơn vị ({{currency}})",
    "currentStock": "Tồn hiện tại",
    "minimumStock": "Tồn tối thiểu",
    "minStockLevel": "Mức tồn tối thiểu",
    "costPrice": "Giá vốn",
    "sellingPrice": "Giá bán ({{currency}})",
    "supplier": "Nhà cung cấp",
    "supplierName": "Tên nhà cung cấp",
    "contactPerson": "Người liên hệ",
    "phone": "Điện thoại",
    "email": "Email",
    "address": "Địa chỉ",
    "street": "Địa chỉ (Số nhà, Tên đường)",
    "province": "Tỉnh/Thành phố",
    "ward": "Phường/Xã",
    "supplierPhone": "SĐT nhà cung cấp",
    "supplierEmail": "Email nhà cung cấp",
    "supplierAddress": "Địa chỉ nhà cung cấp",
    "supplierStreet": "Số nhà, Tên đường",
    "supplierProvince": "Tỉnh/Thành phố",
    "supplierWard": "Phường/Xã",
    "expiryDate": "Hạn sử dụng",
    "batchNumber": "Số lô",
    "trackingMode": "Theo dõi tồn",
    "tracking": "Truy xuất",
    "serialNumber": "Số serial",
    "status": "Trạng thái",
    "clinic": "Phòng khám",
    "warehouse": "Kho",
    "patient": "Bệnh nhân",
    "patientSearchPlaceholder": "Tìm bệnh nhân",
    "dentist": "Bác sĩ",
    "treatmentPlanItem": "Dịch vụ điều trị",
    "commissionDeductible": "Trừ hoa hồng khi xuất điều trị",
    "manufacturer": "Hãng sản xuất",
    "itemNotes": "Ghi chú mặt hàng",
    "lastStockUpdate": "Cập nhật tồn lần cuối",
    "fromClinic": "Kho nguồn",
    "toClinic": "Kho đích",
    "notes": "Ghi chú",
    "reason": "Lý do",
    "issueReason": "Lý do xuất",
    "receiptDate": "Ngày nhập",
    "issueDate": "Ngày xuất",
    "receivedBy": "Người nhập",
    "issuedBy": "Người xuất",
    "transferredBy": "Người chuyển",
    "countedBy": "Người kiểm kê",
    "stocktakeDate": "Ngày kiểm kê",
    "transferDate": "Ngày điều chuyển",
    "quantity": "Số lượng",
    "unitCost": "Đơn giá",
    "unitCostSnapshot": "Giá vốn (lúc ghi sổ)",
    "commissionDeductibleAtIssue": "Trừ HH (lúc ghi sổ)",
    "lineTotal": "Thành tiền",
    "total": "Tổng",
    "totalAmount": "Tổng tiền",
    "totalProducts": "Tổng sản phẩm",
    "totalQuantity": "Tổng số lượng",
    "totalVariance": "Tổng chênh lệch",
    "systemQuantity": "Tồn HT",
    "actualQuantity": "Tồn TT",
    "variance": "Chênh lệch",
    "lastStockUpdate": "Cập nhật tồn lần cuối",
    "selectedClinic": "Phòng khám đã chọn"
  },
  "table": {
    "itemName": "Tên sản phẩm",
    "code": "Mã phiếu",
    "productCode": "Mã SP",
    "category": "Danh mục SP",
    "unit": "Đơn vị",
    "price": "Đơn giá",
    "sellingPrice": "Giá bán",
    "manufacturer": "Hãng SX",
    "stockState": "Trạng thái tồn",
    "lastStockUpdate": "Cập nhật tồn",
    "stock": "Tồn kho",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "date": "Ngày",
    "transferDate": "Ngày chuyển",
    "clinic": "Phòng khám",
    "warehouse": "Kho",
    "from": "Từ kho",
    "to": "Đến kho",
    "items": "Số lượng",
    "patient": "Bệnh nhân",
    "lines": "Số dòng",
    "totalAmount": "Tổng tiền",
    "reason": "Lý do",
    "qty": "SL",
    "unitCost": "Đơn giá",
    "lineTotal": "Thành tiền",
    "lineNo": "STT dòng",
    "note": "Ghi chú",
    "createdBy": "Người tạo",
    "updatedBy": "Người cập nhật",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật lần cuối",
    "postedBy": "Người ghi sổ",
    "postedAt": "Ngày ghi sổ",
    "type": "Loại",
    "change": "Thay đổi",
    "stockAfter": "Tồn sau",
    "by": "Người thực hiện",
    "totalVariance": "Tổng chênh lệch",
    "min": "Tồn tối thiểu",
    "value": "Giá trị",
    "deficit": "Thiếu",
    "in": "Tổng nhập",
    "out": "Tổng xuất",
    "net": "Chênh lệch",
    "item": "Tên sản phẩm"
  },
  "lineEditor": {
    "title": "Chi tiết mặt hàng",
    "productList": "Danh sách sản phẩm",
    "addLine": "Thêm dòng",
    "searchItem": "Nhập tên hoặc mã mặt hàng...",
    "noMatchingItems": "Không có mặt hàng phù hợp",
    "noItemsYet": "Chưa có mặt hàng",
    "empty": "Chưa có dòng. Thêm ít nhất một mặt hàng.",
    "emptyStocktake": "Chưa có dòng",
    "exceedsAvailable": "Vượt quá số còn lại ({{count}})",
    "serialPlaceholder": "Mỗi serial một dòng",
    "serialQtyHint": "Nhập serial",
    "serialPickPlaceholder": "Chọn hoặc quét serial",
    "serialAddPlaceholder": "Thêm serial…",
    "serialPickHint": "Chọn từ kho, hoặc gõ/quét rồi Enter",
    "lotPlaceholder": "Chọn lô trong kho",
    "selectClinicFirst": "Chọn phòng khám trước",
    "selectLotFirst": "Chọn lô trước",
    "fefoPreview": "FEFO gợi ý"
  },
  "picker": {
    "label": "Mặt hàng",
    "browse": "Tất cả",
    "title": "Xem tất cả sản phẩm",
    "search": "Tìm sản phẩm",
    "selectAll": "Chọn tất cả",
    "unselectAll": "Bỏ chọn tất cả",
    "addSelected": "Thêm ({{count}})",
    "noItemsFound": "Không tìm thấy sản phẩm"
  },
  "updateStock": {
    "title": "Cập nhật tồn",
    "addRemove": "Thêm/Bớt tồn",
    "helper": "Dùng số dương để thêm, số âm để bớt",
    "addStock": "Thêm tồn",
    "removeStock": "Bớt tồn",
    "addTo": "Thêm tồn cho {{name}}",
    "removeFrom": "Bớt tồn từ {{name}} (Tồn hiện tại: {{stock}} {{unit}})",
    "currentStockLabel": "Tồn hiện tại:"
  },
  "actions": {
    "refresh": "Làm mới",
    "back": "Quay lại",
    "view": "Xem",
    "viewDetails": "Xem chi tiết",
    "edit": "Sửa",
    "editDocument": "Chỉnh sửa",
    "delete": "Xóa",
    "discontinue": "Ngừng dùng",
    "createStockIn": "Tạo phiếu nhập",
    "createStocktake": "Tạo phiếu kiểm kê",
    "add": "Thêm",
    "remove": "Bớt",
    "update": "Cập nhật",
    "save": "Lưu",
    "saveDraft": "Lưu nháp",
    "post": "Ghi sổ",
    "close": "Đóng",
    "cancel": "Hủy",
    "saving": "Đang lưu...",
    "addItem": "Thêm mặt hàng",
    "updateItem": "Cập nhật mặt hàng",
    "searchCode": "Tìm theo mã",
    "itemHistory": "Lịch sử mặt hàng",
    "discontinuing": "Đang ngừng dùng..."
  },
  "history": {
    "title": "Lịch sử mặt hàng",
    "empty": "Chưa có thay đổi nào trên mặt hàng này."
  },
  "hints": {
    "itemCodeAuto": "Để trống để hệ thống tự sinh mã (PROD-0001, PROD-0002, …)"
  },
  "placeholders": {
    "itemName": "Ví dụ: Găng tay khám",
    "itemCode": "Ví dụ: PROD-0001",
    "category": "Chọn danh mục",
    "unit": "Chọn đơn vị",
    "unitPrice": "Ví dụ: 0",
    "sellingPrice": "Ví dụ: 0",
    "minimumStock": "Ví dụ: 0",
    "description": "Ví dụ: Găng tay dùng một lần",
    "manufacturer": "Ví dụ: 3M",
    "itemNotes": "Ghi chú nội bộ trên hồ sơ mặt hàng",
    "supplier": "Chọn nhà cung cấp",
    "clinic": "Chọn phòng khám",
    "notes": "Nhập ghi chú",
    "fromWarehouse": "Chọn kho nguồn",
    "toWarehouse": "Chọn kho đích",
    "warehouse": "Chọn kho",
    "dentist": "Chọn bác sĩ",
    "treatmentPlanItem": "Chọn dịch vụ điều trị"
  },
  "validation": {
    "itemNameRequired": "Vui lòng nhập tên mặt hàng",
    "itemNameTooLong": "Tên mặt hàng không được vượt quá {{max}} ký tự.",
    "itemCodeRequired": "Vui lòng nhập mã mặt hàng",
    "categoryRequired": "Vui lòng chọn danh mục",
    "unitRequired": "Vui lòng chọn đơn vị",
    "unitPriceRequired": "Vui lòng nhập đơn giá",
    "currentStockRequired": "Vui lòng nhập tồn hiện tại",
    "currentStockNonNegative": "Tồn hiện tại phải là số không âm",
    "minStockRequired": "Vui lòng nhập tồn tối thiểu",
    "minStockNonNegative": "Tồn tối thiểu phải là số không âm",
    "priceRequired": "Vui lòng nhập giá",
    "priceNonNegative": "Giá phải là số không âm",
    "manufacturerTooLong": "Hãng sản xuất không được vượt quá {{max}} ký tự.",
    "notesTooLong": "Ghi chú không được vượt quá {{max}} ký tự.",
    "selectClinic": "Vui lòng chọn phòng khám",
    "selectWarehouse": "Vui lòng chọn kho",
    "noWarehouse": "Phòng khám này chưa có kho. Hãy tạo kho trong Cấu hình kho.",
    "warehousesMustDiffer": "Kho nguồn và kho đích phải khác nhau",
    "clinicMissing": "Thiếu thông tin phòng khám cho mặt hàng này",
    "validAmount": "Vui lòng nhập số hợp lệ",
    "validQuantity": "Vui lòng nhập số lượng hợp lệ",
    "cannotRemoveMoreThan": "Không thể xuất quá tồn hiện tại ({{count}})",
    "selectClinicScope": "Vui lòng chọn phòng khám trước khi cập nhật tồn",
    "atLeastOneLine": "Thêm ít nhất một dòng hợp lệ",
    "dateRequired": "Vui lòng chọn ngày",
    "patientRequiredForTreatment": "Xuất điều trị cần chọn bệnh nhân",
    "treatmentPlanItemRequired": "Xuất điều trị cần chọn hạng mục kế hoạch",
    "noTreatmentItems": "Bệnh nhân chưa có hạng mục điều trị (hoặc tất cả đã hủy)",
    "actualQuantityNonNegative": "Số lượng thực tế phải bằng hoặc lớn hơn 0 trên mỗi dòng",
    "selectFromClinic": "Vui lòng chọn kho nguồn",
    "selectToClinic": "Vui lòng chọn kho đích",
    "clinicsMustDiffer": "Kho nguồn và kho đích phải khác nhau",
    "bothClinicsRequired": "Bắt buộc chọn cả hai chi nhánh"
  },
  "dialogs": {
    "deleteTitle": "Xóa mặt hàng",
    "discontinueTitle": "Ngừng dùng mặt hàng",
    "confirmDelete": "Bạn có chắc muốn xóa \"{{name}}\"? Không thể hoàn tác.",
    "confirmDeleteSimple": "Bạn có chắc muốn xóa mặt hàng này?",
    "confirmDeleteOrDiscontinue": "Mặt hàng đã có lịch sử kho sẽ chuyển sang ngừng dùng; mặt hàng chưa phát sinh sẽ bị xóa. Tiếp tục?",
    "confirmDeleteOrDiscontinueNamed": "Mặt hàng \"{{name}}\" đã có lịch sử kho sẽ chuyển sang ngừng dùng; chưa phát sinh sẽ bị xóa. Tiếp tục?",
    "cancelConfirmBody": "Phiếu nháp sẽ bị đánh dấu hủy. Không thay đổi tồn kho."
  },
  "toasts": {
    "itemCreated": "Đã tạo mặt hàng thành công",
    "itemUpdated": "Đã cập nhật mặt hàng thành công",
    "itemDeleted": "Đã xóa mặt hàng thành công",
    "itemDiscontinued": "Đã chuyển mặt hàng sang ngừng dùng",
    "itemSaveFailed": "Lưu mặt hàng thất bại",
    "itemDeleteFailed": "Xóa mặt hàng thất bại",
    "loadItemsFailed": "Không tải được danh sách mặt hàng",
    "loadItemFailed": "Không tải được mặt hàng",
    "stockUpdated": "Đã cập nhật tồn kho",
    "stockUpdateFailed": "Cập nhật tồn kho thất bại",
    "stockAdded": "Đã thêm {{count}} {{unit}} vào kho",
    "stockRemoved": "Đã bớt {{count}} {{unit}} khỏi kho",
    "draftUpdated": "Đã cập nhật phiếu nháp",
    "noMovements": "Chưa có biến động kho."
  },
  "warehouses": {
    "search": "Tìm kho",
    "add": "Thêm kho",
    "addTitle": "Thêm kho",
    "editTitle": "Sửa kho",
    "permissionDenied": "Bạn không có quyền xem kho.",
    "empty": "Chưa có kho",
    "delete": "Xóa kho",
    "deleteConfirmTitle": "Xóa kho?",
    "deleteConfirmBody": "Kho chưa dùng sẽ bị xóa. Kho đã có phiếu hoặc tồn thì không xóa được.",
    "fields": {
      "name": "Tên kho",
      "status": "Trạng thái"
    },
    "placeholders": {
      "name": "Ví dụ: Kho chính"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên kho"
    },
    "toasts": {
      "created": "Đã tạo kho",
      "updated": "Đã cập nhật kho",
      "deleted": "Đã xóa kho",
      "saveFailed": "Lưu kho thất bại",
      "deleteFailed": "Xóa kho thất bại",
      "loadFailed": "Không tải được danh sách kho",
      "nameExists": "Tên kho đã tồn tại trong phòng khám này",
      "inUse": "Kho đã có phiếu hoặc tồn. Hãy chuyển sang Ngừng dùng."
    },
    "history": {
      "action": "Lịch sử",
      "title": "Lịch sử kho",
      "empty": "Chưa có thay đổi nào trên kho này."
    }
  },
  "suppliers": {
    "pages": {
      "listTitle": "Nhà cung cấp",
      "addTitle": "Thêm nhà cung cấp",
      "editTitle": "Sửa nhà cung cấp",
      "permissionDenied": "Bạn không có quyền xem nhà cung cấp."
    },
    "fields": {
      "code": "Mã NCC",
      "name": "Tên NCC",
      "contacts": "Người liên hệ",
      "contactPerson": "Người liên hệ",
      "contactN": "Người liên hệ {{n}}",
      "contactName": "Họ và tên",
      "phone": "Điện thoại",
      "email": "Email",
      "address": "Địa chỉ NCC",
      "notes": "Ghi chú",
      "status": "Trạng thái"
    },
    "placeholders": {
      "code": "Ví dụ: NCC-0001",
      "name": "Ví dụ: Công ty Việt Quang",
      "notes": "Nhập ghi chú",
      "contactName": "Nhập họ và tên",
      "phone": "Ví dụ: 0901234567",
      "email": "Nhập email",
      "province": "Nhập tỉnh/thành phố",
      "ward": "Nhập phường/xã",
      "street": "Nhập số nhà, tên đường"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "actions": {
      "add": "Thêm NCC",
      "addContact": "Thêm người liên hệ",
      "removeContact": "Xóa người liên hệ",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "history": "Lịch sử"
    },
    "search": "Tìm nhà cung cấp",
    "empty": "Chưa có nhà cung cấp",
    "hints": {
      "codeAuto": "Để trống để hệ thống tự sinh mã (NCC-0001, NCC-0002, …)"
    },
    "validation": {
      "codeRequired": "Nhập mã nhà cung cấp",
      "nameRequired": "Nhập tên nhà cung cấp",
      "contactNameRequired": "Mỗi người liên hệ cần có họ tên",
      "contactNameTooLong": "Họ tên không được vượt quá {{max}} ký tự.",
      "notesTooLong": "Ghi chú không được vượt quá {{max}} ký tự.",
      "emailTooLong": "Email không được vượt quá {{max}} ký tự."
    },
    "history": {
      "title": "Lịch sử nhà cung cấp",
      "empty": "Chưa có thay đổi nào trên nhà cung cấp này."
    },
    "dialogs": {
      "confirmDeactivate": "Ngừng dùng nhà cung cấp này?"
    },
    "toasts": {
      "created": "Đã tạo nhà cung cấp",
      "updated": "Đã cập nhật nhà cung cấp",
      "deactivated": "Đã ngừng dùng nhà cung cấp",
      "saveFailed": "Lưu nhà cung cấp thất bại",
      "deactivateFailed": "Ngừng dùng thất bại",
      "loadFailed": "Không tải được danh sách nhà cung cấp"
    }
  },
  "misc": {
    "notAvailable": "—",
    "postedBy": "Đã ghi sổ {{date}} bởi {{name}}",
    "itemsCount": "{{count}} mặt hàng"
  }
}
